import { safeExecute } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, StringField, Int32Field, BooleanField, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class AudioRegionBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new AudioRegionBox({
            uuid,
            graph,
            name: "AudioRegionBox",
            pointerRules: {
                accepts: [Pointers.Selection, Pointers.Editing],
                mandatory: false,
            },
        }), constructor);
    }
    static ClassName = "AudioRegionBox";
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitAudioRegionBox, this);
    }
    get regions() {
        return this.getField(1);
    }
    get file() {
        return this.getField(2);
    }
    get playback() {
        return this.getField(3);
    }
    get position() {
        return this.getField(10);
    }
    get duration() {
        return this.getField(11);
    }
    get loopOffset() {
        return this.getField(12);
    }
    get loopDuration() {
        return this.getField(13);
    }
    get mute() {
        return this.getField(14);
    }
    get label() {
        return this.getField(15);
    }
    get hue() {
        return this.getField(16);
    }
    get gain() {
        return this.getField(17);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "regions",
                pointerRules: NoPointers,
            }, Pointers.RegionCollection, true),
            2: PointerField.create({
                parent: this,
                fieldKey: 2,
                fieldName: "file",
                pointerRules: NoPointers,
            }, Pointers.AudioFile, true),
            3: StringField.create({
                parent: this,
                fieldKey: 3,
                fieldName: "playback",
                pointerRules: NoPointers,
            }, "pitch"),
            10: Int32Field.create({
                parent: this,
                fieldKey: 10,
                fieldName: "position",
                pointerRules: NoPointers,
            }),
            11: Int32Field.create({
                parent: this,
                fieldKey: 11,
                fieldName: "duration",
                pointerRules: NoPointers,
            }),
            12: Int32Field.create({
                parent: this,
                fieldKey: 12,
                fieldName: "loopOffset",
                pointerRules: NoPointers,
            }),
            13: Int32Field.create({
                parent: this,
                fieldKey: 13,
                fieldName: "loopDuration",
                pointerRules: NoPointers,
            }),
            14: BooleanField.create({
                parent: this,
                fieldKey: 14,
                fieldName: "mute",
                pointerRules: NoPointers,
            }),
            15: StringField.create({
                parent: this,
                fieldKey: 15,
                fieldName: "label",
                pointerRules: NoPointers,
            }),
            16: Int32Field.create({
                parent: this,
                fieldKey: 16,
                fieldName: "hue",
                pointerRules: NoPointers,
            }),
            17: Float32Field.create({
                parent: this,
                fieldKey: 17,
                fieldName: "gain",
                pointerRules: NoPointers,
            }),
        };
    }
}
